import { config } from 'config';
import i18n from 'i18nextInstance';
const { company } = config;

export const HEADERS = [{
    key: 'last_name',
    label: i18n.t('Apellido')
}, {
    key: 'first_name',
    label: i18n.t('Nombre')
}, {
    key: 'identification',
    label: i18n.t('DNIPaciente')
}];

export const DOWNLOAD_HEADERS = [...HEADERS, {
    key: 'workplace',
    label: i18n.t('Lugar de trabajo')
}, {
    key: 'position',
    label: i18n.t('Cargo')
}, {
    key: 'hr_head',
    label: i18n.t('Jefe de RRHH')
}, {
    hidden: !company,
    key: 'company',
    label: i18n.t('Empresa')
}].filter(({ hidden }) => !hidden);
